/* Rquiere de mixin.js */

var shipping = {
    data() {
        return {
            dateFromShippings: '2020-07-15',
            dateToShippings: '2020-07-18',
            listShippings: [],
            listShippingsForAssingFreightOrder: [],
            methodsShipping: {
                create: 'shipping/register',
                delete: '/delete',
                get: 'shippings',
                show: 'shipping/',
                updateField: '/updateField',
                shippingTrackingsShippingCreate: '/trackingsShipping/register',
                searchForAssignFreightOrder: '/searchForAssignFreightOrder'
            },
            objectShipping: {
                id: 0,
                barcode: '',
                document_number: '',
                commentary: '',
                sendto: '',
                address: '',
                comuna: '',
                color: '',
                phone: '',
                paid_shipping: 0,
                packages: 0,
                weight: 0,
                transport_id: 0,
                transport: '',
                transport_color: '',
                transports: {},
                freight_order: '',
                total_price: 0,
                status_id: 1,
                status: '',
                manifesto: [],
                manifesto_id: 0,
                created_at: '',
                updated_at: '',
                shipping_packages: [],
                shipping_request_id: 0,
                shipping_shippings_request: [],
                shipping_trackings_shipping: []
            },
            paginationListShippings: [],
            qRowsShipping: 25,
            searchShipping: '',
            searchShippingForAssingFreightOrder: '',
            selectedListShippingsForAssingFreightOrder: 0,
            trackingsShippingShippingRequest: [
                { trackings_shipping_id: '3', trackings_shipping_status_name: 'Despachado', trackings_shipping_request_id: '13' },
                { trackings_shipping_id: '4', trackings_shipping_status_name: 'Entregado', trackings_shipping_request_id: '14' },
            ]
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        addListShippings(newShipping) {
            this.listShippings.unshift(newShipping)
            if (this.listShippings.length > this.qRowsShipping) {
                this.listShippings.splice(this.qRowsShipping, 1)
            }
        },
        addListShippingShippingsRequest(item) {
            this.objectShipping.shipping_shippings_request.push(item)
        },
        addShippingTrackingsShipping(id, trackingsShippingId, observation = '') {
            let param =
                { 'trackingsShippingId': trackingsShippingId, 'observation': observation }
            this.$emit('showLockScreen', 'Agregando seguimiento . . .')
            this.axiosActionIS(this.getApiBackend + this.methodsShipping.show + id + this.methodsShipping.shippingTrackingsShippingCreate, 'POST', 'addShippingTrackingsShippingResult', param)
        },
        addShippingTrackingsShippingResult(response) {
            if (response.data.success == true) {
                this.$snotify.info('Se ha actualizado el estado!!!', 'Actualizado')
            }
            this.updateShippingStatus(response.data.data)
            this.socketEmit(['NEW_SHIPPING_TRACKINGS_SHIPPING'], response.data.data)
            this.addShippingTrackingsShippingResultLocal(response)
        },
        addShippingTrackingsShippingResultLocal(response) {
            console.log('addShippingTrackingsShippingResultLocal no desarrollado', response)
        },
        deleteItemListShippings(id) {
            let index = this.listShippings.map((el) => parseInt(el.id)).indexOf(parseInt(id))
            if (index > -1)
                return this.listShippings.splice(index, 1)
            return false
        },
        deleteListShippingShippingsRequest(id) {
            let index = this.objectShipping.shipping_shippings_request.map((el) => parseInt(el.shipping_request_id)).indexOf(parseInt(id))
            return this.objectShipping.shipping_shippings_request.splice(index, 1)
        },
        deleteListShippingManifestoShipping(id, manifestoId) {
            let index = this.listShippings.map((el) => parseInt(el.id)).indexOf(parseInt(id))
            if (index > -1) {
                index = this.listShippings[index].manifesto_shipping.map((el) => parseInt(el.manifesto_id)).indexOf(parseInt(manifestoId))
                if (index > -1) {
                    this.listShippings[index].manifesto.splice(index, 1)
                    return this.listShippings[index].manifesto_shipping.splice(index, 1)
                }
            }
            return false
        },
        deleteShipping(id) {
            this.$emit('showLockScreen', 'Borrando Envio . . .')
            this.axiosActionIS(this.getApiBackend + this.methodsShipping.show + id + this.methodsShipping.delete, 'DELETE', 'deleteShippingResult')
        },
        deleteShippingResult(response) {
            if (response.data.success) {
                this.socketEmit(['DELETE_SHIPPING'], response.data.data)
                this.deleteItemListShippings(response.data.data)
            }
        },
        changeQRowsShipping() {
            localStorage.setItem('qRowsShipping', this.qRowsShipping)
            this.getAllShippings()
        },
        clearObjectShipping() {
            this.objectShipping.id = 0
            this.objectShipping.document_number = ''
            this.objectShipping.barcode = ''
            this.objectShipping.commentary = ''
            this.objectShipping.sendto = ''
            this.objectShipping.address = ''
            this.objectShipping.comuna = ''
            this.objectShipping.color = ''
            this.objectShipping.phone = ''
            this.objectShipping.packages = 0
            this.objectShipping.weight = 0
            this.objectShipping.paid_shipping = 0
            this.objectShipping.transport_id = 0
            this.objectShipping.transport = ''
            this.objectShipping.transport_color = ''
            this.objectShipping.freight_order = ''
            this.objectShipping.total_price = 0
            this.objectShipping.status_id = 0
            this.objectShipping.status = ''
            this.objectShipping.manifesto_id = 0
            this.objectShipping.created_at = ''
            this.objectShipping.updated_at = ''
            this.objectShipping.shipping_request_id = 0
            this.objectShipping.manifesto = []
            this.objectShipping.shipping_packages = []
            this.objectShipping.shipping_shippings_request = []
            this.objectShipping.shipping_trackings_shipping = []
        },
        clearObjectShippingHeader() {
            this.objectShipping.document_number = ''
            this.objectShipping.barcode = ''
            this.objectShipping.commentary = ''
            this.objectShipping.sendto = item.sendto
            this.objectShipping.address = item.address
            this.objectShipping.comuna = item.comuna
            this.objectShipping.phone = item.phone
            this.objectShipping.packages = 0
            this.objectShipping.weight = 0
            this.objectShipping.paid_shipping = item.paid_shipping
            this.objectShipping.transport_id = item.transport_id
            this.objectShipping.transport = item.transport
            this.objectShipping.shipping_request_id = 0
        },
        editObjectShipping(item) {
            this.setObjectShipping(item)
            this.$refs.btnShowShippingNewModal.click()
        },
        getAllShippings(page = 1) {
            let parameters = '?page=' + page + '&qRow=' + this.qRowsShipping + '&fromDate=' + this.dateFromShippings + '&toDate=' + this.dateToShippings + '&search=' + this.searchShipping
            this.$emit('showLockScreen', 'Obteniendo Envios . . .')
            this.axiosActionIS(this.getApiBackend + this.methodsShipping.get + parameters, 'GET', 'getAllShippingsResult')
        },
        getAllShippingsResult(response) {
            this.listShippings = response.data.data
            this.paginationListShippings = response.data.paginate
            this.searchShipping = (this.searchShipping == 'allRows') ? '' : this.searchShipping
            setTimeout(() => { this.$refs.searchShipping.focus() }, 10)
        },
        getInfoShippingCourrier(shipping) {
            if (shipping.transport_id == 2 && shipping.freight_order != '') {
                this.listOfStarken = []
                this.searchOFStarken(shipping.freight_order, 2)
            } else if (shipping.transport_id == 3 && shipping.freight_order != '') {
                this.copyClipboard(shipping.freight_order)
                window.open('https://www.correos.cl/seguimiento-en-linea', '_blank');
            } else if (shipping.transport_id == 5 && shipping.freight_order != '') {
                this.copyClipboard(shipping.freight_order)
                window.open('https://www.chilexpress.cl/Views/ChilexpressCL/Resultado-busqueda.aspx', '_blank');
            } else {
                alert('Numero de Envío: ' + shipping.id +
                    '\nOrden de flete: ' + shipping.freight_order +
                    '\nEnviado a: ' + shipping.sendto)
            }
        },
        getShipping(id) {
            this.axiosActionIS(this.getApiBackend + this.methodsShipping.show + id, 'GET', 'getShippingResult')
        },
        getShippingResult(response) {
            if (response.data.success) {
                this.setObjectShipping(response.data.data)
            } else {
            }
            this.getShippingResultLocal(response)
        },
        getShippingResultLocal(response) {
            console.log('getShippingResultLocal no desarrollado', response)
        },
        saveShipping() {
            let method = (this.objectShipping.id == 0) ? 'POST' : 'PUT'
            this.$emit('showLockScreen', 'Guardando datos . . .')
            if (method == 'POST') {
                this.axiosActionIS(this.getApiBackend + this.methodsShipping.create, method, 'saveShippingPOSTResult', this.objectShipping)
            } else if (method == 'PUT') {
                console.log(this.getApiBackend + this.methodsShipping.update, 'PUT')
                //this.axiosActionIS(this.getApiBackend + this.methods.shippingRequestUpdate, method, 'resultSaveShippingRequestPUT', this.objectShippingRequest)
            }
        },
        saveShippingPOSTResult(responseLocal, response) {
            if (response.data.success) {
                if (responseLocal == 'saveShippingPOSTResult') {
                    this.addListShippings(response.data.data)
                    this.saveShippingPOSTResultLocal(response.data.data)
                    this.socketEmit(['NEW_SHIPPING'], response.data.data)
                } else if (responseLocal == 'saveShippingPOSTResult') {
                    this.updateItemListManifesto(response.data.data)
                    this.socketEmit(['UPDATE_SHIPPING'], response.data.data)
                }
                console.log('Envio guardado con exito')
            } else {
                console.log(response)
            }
        },
        saveShippingPOSTResultLocal(newShipping) {
            console.log('saveShippingPOSTResultLocal no desarrollado', newShipping)
        },
        searchForAssignFreightOrder(sendto, comuna = '') {
            let parameters = '?sendto=' + sendto + '&comuna=' + comuna
            let url = this.getApiBackend + this.methodsShipping.get + this.methodsShipping.searchForAssignFreightOrder + parameters
            this.axiosActionIS(url, 'GET', 'searchForAssignFreightOrderResult')
        },
        searchForAssignFreightOrderResult(response) {
            this.listShippingsForAssingFreightOrder = response.data.data
            this.searchForAssignFreightOrderResultLocal(response)
        },
        searchForAssignFreightOrderResultLocal(response) {
            console.log('searchForAssignFreightOrderResultLocal no desarrollado', response)
        },
        setListeningShipping() {
            this.sockets.subscribe('DELETE_SHIPPING', (data) => { this.deleteItemListShippings(data.body) })
            this.sockets.subscribe('NEW_SHIPPING', (data) => { this.addListShippings(data.body) })
            this.sockets.subscribe('UPDATE_SHIPPING', (data) => { this.setListShippingsByItem(data.body) })
        },
        setListShippingsByItem(item) {
            let index = this.listShippings.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
            if (index > -1) {
                this.listShippings[index].address = item.address
                this.listShippings[index].color = item.color
                this.listShippings[index].comuna = item.comuna
                this.listShippings[index].document_number = item.document_number
                this.listShippings[index].freight_order = item.freight_order
                this.listShippings[index].packages = item.packages
                this.listShippings[index].packagesOld = item.packagesOld
                this.listShippings[index].paid_shipping = item.paid_shipping
                this.listShippings[index].phone = item.phone
                this.listShippings[index].sendto = item.sendto
                this.listShippings[index].shipping_shipping_sequest = item.shipping_shipping_sequest
                this.listShippings[index].status = item.status
                this.listShippings[index].status_id = item.status_id
                this.listShippings[index].total_price = item.total_price
                this.listShippings[index].transport = item.transport
                this.listShippings[index].transport_id = item.transport_id
                this.listShippings[index].updated_at = item.updated_at
                this.listShippings[index].weight = item.weight
                this.listShippings[index].weightOld = item.weightOld
            }
        },
        setObjectShipping(item) {
            this.objectShipping.id = item.id
            this.objectShipping.document_number = item.document_number
            this.objectShipping.barcode = item.barcode
            this.objectShipping.commentary = item.commentary
            this.objectShipping.sendto = item.sendto
            this.objectShipping.address = item.address
            this.objectShipping.comuna = item.comuna
            this.objectShipping.color = item.color
            this.objectShipping.phone = item.phone
            this.objectShipping.packages = item.packages
            this.objectShipping.weight = item.weight
            this.objectShipping.paid_shipping = item.paid_shipping
            this.objectShipping.transport_id = item.transport_id
            this.objectShipping.transport = item.transport
            this.objectShipping.transport_color = item.transport_color
            this.objectShipping.freight_order = item.freight_order
            this.objectShipping.total_price = item.total_price
            this.objectShipping.status_id = item.status_id
            this.objectShipping.status = item.status
            this.objectShipping.manifesto_id = 1
            this.objectShipping.manifesto = item.manifesto
            this.objectShipping.created_at = item.created_at
            this.objectShipping.updated_at = item.updated_at
            this.objectShipping.shipping_packages = item.shipping_packages
            this.objectShipping.shipping_shippings_request = item.shipping_shippings_request
            this.objectShipping.shipping_request_id = item.shipping_request_id
            this.objectShipping.shipping_trackings_shipping = item.shipping_trackings_shipping
        },
        showShipping(id, action = 'view') {
            let param = '?action=' + action
            let url = this.getApiBackend + this.methodsShipping.show + id + param
            this.axiosActionIS(url, 'GET', 'showShippingResult', null)
        },
        showShippingResult(response) {
            this.showShippingResultLocal(response)
        },
        showShippingResultLocal(response) {
            console.log('showShippingResultLocal no está desarrollado', response)
        },
        toPrintLabelShippingAll(shipping_packages, firstItem = true) {
            shipping_packages.forEach((object, index) => {
                if ((firstItem && index == 0) || (index > 0))
                    this.toPrintLabelShippingOne(object)
            })
        },
        toPrintLabelShippingOne(object) {
            let item = {
                'sendto': this.objectShipping.sendto,
                'address': this.objectShipping.address,
                'comuna': this.objectShipping.comuna,
                'phone': this.objectShipping.phone,
                'transport_id': this.objectShipping.transport_id,
                'transport': this.objectShipping.transport,
                'paid_shipping_desc': (this.objectShipping.paid_shipping == 1) ? 'CTACTE' : 'POR PAGAR',
                'clicod': 'EV' + this.objectShipping.id,
                'cliente': '0',
                'campomisdesc': '0',
                'barcode': object.barcode
            }
            this.toPrintShipping(item)
        },
        toPrintShipping(item) {
            let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(item.transport_id))
            let arrayZPL = []
            arrayZPL.push({ 'name': 'sendto', 'value': this.cleanedStringZPL(item.sendto).toUpperCase() })
            arrayZPL.push({ 'name': 'address', 'value': this.cleanedStringZPL(item.address).toUpperCase() })
            arrayZPL.push({ 'name': 'comuna', 'value': this.cleanedStringZPL(item.comuna).toUpperCase() })
            arrayZPL.push({ 'name': 'phone', 'value': this.cleanedStringZPL(item.phone).toUpperCase() })
            arrayZPL.push({ 'name': 'img_zpl', 'value': (index > 0) ? this.listTransports[index].img_zpl : item.transport })
            arrayZPL.push({ 'name': 'paid_shipping_desc', 'value': item.paid_shipping_desc })
            arrayZPL.push({ 'name': 'clicod', 'value': item.clicod })
            arrayZPL.push({ 'name': 'cliente', 'value': item.cliente })
            arrayZPL.push({ 'name': 'codbareti', 'value': item.barcode })
            arrayZPL.push({ 'name': 'campomisdesc', 'value': item.campomisdesc })
            arrayZPL.push({ 'name': 'total_price', 'value': item.campomisdesc })
            this.replaceZPLVariableFromArray(arrayZPL)
            this.toPrintWithVariables()
        },
        updateShippingByField(id, field, value) {
            let data = { field: field, value: value }
            this.axiosActionIS(this.getApiBackend + this.methodsShipping.show + id + this.methodsShipping.updateField, 'PUT', 'updateShippingByFieldResult', data)
        },
        updateShippingByFieldResult(response) {
            if (response.data.success) {
                this.socketEmit(['UPDATE_SHIPPING'], response.data.data)
                this.setListShippingsByItem(response.data.data)
            }
            this.updateShippingByFieldResultLocal(response)
        },
        updateShippingByFieldResultLocal(response) {
            console.log('updateShippingByFieldResultLocal no desarrollado', response)
        },
        updateShippingStatus(shippingTrackingsShipping) {
            if (Object.entries(shippingTrackingsShipping.statu).length > 0) {
                let index = this.listShippings.map((el) => parseInt(el.id)).indexOf(parseInt(shippingTrackingsShipping.shipping_id))
                if (index > -1) {
                    this.listShippings[index].status_id = shippingTrackingsShipping.statu.id
                    this.listShippings[index].status = shippingTrackingsShipping.statu.name
                    this.listShippings[index].color = shippingTrackingsShipping.statu.color
                }
            }
        }

    },
};

export default shipping;